// 文本
export const TEXT = 'TEXT';
// TEXT下的 subType
export const TEXT_INPUT = 'INPUT';
export const TEXT_TEXTAREA = 'TEXTAREA';
export const TEXT_NUMBER = 'NUMBER';
export const TEXT_RICH_TEXT = 'RICH_TEXT';
export const TEXT_SIMPLE_RICH_TEXT = 'SIMPLE_RICH_TEXT';
export const TEXT_EXTEND_RICH_TEXT = 'EXTEND_RICH_TEXT';
export const TEXT_FULL_RICH_TEXT = 'FULL_RICH_TEXT';
export const TEXT_DROP_DOWN = 'DROP_DOWN';
export const CHECK_BOX = 'CHECK_BOX';
export const RICH_TEXT_REG = /RICH_TEXT/;

// 富文本类型
export const INSERT_BLANK = 'INSERT_BLANK'; //
export const IDENTIFIER = 'IDENTIFIER';
export const SPLIT = 'SPLIT';
export const MATH_FORMULA = 'MATH_FORMULA';
export const PINYIN = 'PINYIN';

export interface TypeTextObj {
  type: string;
  text: string;
}
export const richTextExtendedList = [
  {
    type: INSERT_BLANK,
    text: '插空',
  },
  {
    type: IDENTIFIER,
    text: '标记',
  },
  {
    type: SPLIT,
    text: '分割',
  },
  {
    type: MATH_FORMULA,
    text: '数学公式',
  },
  {
    type: PINYIN,
    text: '拼音',
  },
];

// 音频
export const AUDIO = 'AUDIO';
export const AUDIO_AUDIO = 'AUDIO';

// 文档
export const DOCUMENT = 'DOCUMENT';
export const DOCUMENT_PPT = 'PPT';

// 图像
export const IMAGE = 'IMAGE';
export const IMAGE_IMAGE = 'IMAGE';
export const IMAGE_ANIMATION = 'ANIMATION';

// 视频
export const VIDEO = 'VIDEO';
export const VIDEO_VIDEO = 'VIDEO';

export const elementMap = {
  IMAGE: '图片',
  AUDIO: '音频',
  DOCUMENT: '文档',
  VIDEO: '视频',
  ANIMATION: '动画',
};
